import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { Close } from "../icons";
import Input from "../common/Input";
import SelectInput from "../common/SelectInput";
import itmImg from "../../assets/item-thumbnail.png";

export default function ItemModal({
  open,
  onClose,
  onSubmit,
  mode = "add",
  initialValues = {},
  categories = [], 
  vendors = [],    
}) {
  const [formData, setFormData] = useState({
    name: "",
    itemPrice: "",
    itemCategory: "",
    itemVendor: "",
    image: null,
  });


  useEffect(() => {
    if (!open) return;
    if (mode === "edit" && initialValues) {
      // Extract IDs if category/vendor are objects, otherwise use as-is
      const categoryValue = 
        typeof initialValues.itemCategory === "object" && initialValues.itemCategory?._id
          ? initialValues.itemCategory._id
          : initialValues.itemCategory || "";
      
      const vendorValue = 
        typeof initialValues.itemVendor === "object" && initialValues.itemVendor?._id
          ? initialValues.itemVendor._id
          : initialValues.itemVendor || "";

      setFormData({
        name: initialValues.name || "",
        itemPrice: initialValues.itemPrice || "",
        itemCategory: categoryValue,
        itemVendor: vendorValue,
        image: initialValues.image || null,
      });
    } else {
      setFormData({
        name: "",
        itemPrice: "",
        itemCategory: "",
        itemVendor: "",
        image: null,
      });
    }
  }, [open, mode, initialValues]);

  function handlePhotoChange(e) {
    const file = e.target.files?.[0];
    if (file) {
      setFormData({ ...formData, image: file });
    }
  }

  async function handleSubmit() {
    await onSubmit?.(formData);
  }

  const title = mode === "edit" ? "Update Item" : "Add New Item";
  const submitLabel = mode === "edit" ? "Update Product" : "Create Product";

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={null}
      panelClassName="w-full max-w-[620px] pt-8 pb-9 px-0 max-h-[90vh] overflow-y-auto sm:max-h-none sm:overflow-visible"
      centered={false}
    >
      <div className="w-full">
        <div className="flex items-center justify-between mb-4 px-4 sm:px-8">
          <p className="text-xl font-bold leading-6 text-black">{title}</p>
          <button onClick={onClose} aria-label="close">
            <Close />
          </button>
        </div>

        <div className="border-t border-[#E5E5E5] pt-5 px-4 sm:pl-7 sm:pr-8">
          <div className="mb-7">
           
            <label className="flex  items-center  justify-center w-full h-[154px] border border-dashed border-[#C3C3C3] rounded-[10px] bg-[#FAFAFA] cursor-pointer hover:bg-[#F0F0F0] transition overflow-hidden">
              <input
                type="file"
                accept="image/*"
                onChange={handlePhotoChange}
                className="hidden"
              />
              {formData.image || initialValues?.itemPicture?.secure_url ? (
                <img
                  src={formData.image ? URL.createObjectURL(formData.image) : initialValues.itemPicture.secure_url}
                  alt="preview"
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="relative w-full h-full">
                  <img src={itmImg} alt="Thumbnail" className="w-full h-full object-contain p-2 opacity-50" />
                  <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/5 hover:bg-black/10 transition">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clipRule="evenodd"
                        d="M16 6.75C15.6685 6.75 15.3505 6.8817 15.1161 7.11612C14.8817 7.35054 14.75 7.66848 14.75 8C14.75 8.33152 14.8817 8.64946 15.1161 8.88388C15.3505 9.1183 15.6685 9.25 16 9.25C16.3315 9.25 16.6495 9.1183 16.8839 8.88388C17.1183 8.64946 17.25 8.33152 17.25 8C17.25 7.66848 17.1183 7.35054 16.8839 7.11612C16.6495 6.8817 16.3315 6.75 16 6.75ZM13.25 8C13.25 7.27065 13.5397 6.57118 14.0555 6.05546C14.5712 5.53973 15.2707 5.25 16 5.25C16.7293 5.25 17.4288 5.53973 17.9445 6.05546C18.4603 6.57118 18.75 7.27065 18.75 8C18.75 8.72935 18.4603 9.42882 17.9445 9.94454C17.4288 10.4603 16.7293 10.75 16 10.75C15.2707 10.75 14.5712 10.4603 14.0555 9.94454C13.5397 9.42882 13.25 8.72935 13.25 8Z"
                        fill="#666666"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.943 1.25H12.057C14.366 1.25 16.175 1.25 17.587 1.44C19.031 1.634 20.171 2.04 21.066 2.934C21.961 3.829 22.366 4.969 22.56 6.414C22.75 7.825 22.75 9.634 22.75 11.943V12.057C22.75 14.366 22.75 16.175 22.56 17.587C22.366 19.031 21.96 20.171 21.066 21.066C20.171 21.961 19.031 22.366 17.586 22.56C16.175 22.75 14.366 22.75 12.057 22.75H11.943C9.634 22.75 7.825 22.75 6.413 22.56C4.969 22.366 3.829 21.96 2.934 21.066C2.039 20.171 1.634 19.031 1.44 17.586C1.25 16.175 1.25 14.366 1.25 12.057V11.943C1.25 9.634 1.25 7.825 1.44 6.413C1.634 4.969 2.04 3.829 2.934 2.934C3.829 2.039 4.969 1.634 6.414 1.44C7.825 1.25 9.634 1.25 11.943 1.25ZM3.995 20.005C3.425 19.435 3.098 18.665 2.926 17.386C2.773 16.245 2.753 14.789 2.75 12.84L4.245 11.532C4.5409 11.2729 4.92423 11.136 5.31732 11.149C5.71041 11.162 6.08386 11.3239 6.362 11.602L10.652 15.892C11.1097 16.3499 11.7142 16.6316 12.3592 16.6876C13.0042 16.7436 13.6483 16.5702 14.178 16.198L14.476 15.988C14.8927 15.695 15.3964 15.5521 15.9049 15.5827C16.4133 15.6132 16.8964 15.8153 17.275 16.156L20.498 19.058C20.5333 19.0893 20.5703 19.117 20.609 19.141C20.4602 19.4624 20.2558 19.7549 20.005 20.005C19.435 20.575 18.665 20.902 17.386 21.074C16.086 21.248 14.378 21.25 12 21.25C9.622 21.25 7.914 21.248 6.614 21.074C5.335 20.902 4.565 20.574 3.995 20.005ZM6.614 2.926C5.335 3.098 4.564 3.426 3.994 3.995C3.425 4.565 3.098 5.335 2.926 6.614C2.781 7.694 2.756 9.054 2.751 10.847L3.258 10.403C3.84037 9.89353 4.59461 9.62445 5.36794 9.65026C6.14128 9.67607 6.87589 9.99484 7.423 10.542L11.713 14.832C11.9211 15.0398 12.1959 15.1675 12.4889 15.1928C12.7819 15.218 13.0744 15.1391 13.315 14.97L13.613 14.76C14.3076 14.2719 15.1472 14.0339 15.9946 14.0849C16.842 14.136 17.647 14.473 18.278 15.041L21.052 17.538L21.074 17.386C21.248 16.086 21.25 14.378 21.25 12C21.25 9.622 21.248 7.914 21.074 6.614C20.902 5.335 20.574 4.564 20.005 3.994C19.435 3.425 18.665 3.098 17.386 2.926C16.086 2.752 14.378 2.75 12 2.75C9.622 2.75 7.914 2.752 6.614 2.926Z"
                        fill="#666666"
                      />
                    </svg>
                    <p className="text-sm leading-6 text-[#666666] font-medium mt-1">Add Photo</p>
                  </div>
                </div>
              )}
            </label>
          </div>

        
          <Input
            label="Product Name *"
            value={formData.name}
            onChange={(e) =>
              setFormData({ ...formData, name: e.target.value })
            }
            placeholder="Enter Product Name"
          />

          {/* Unit Price & Category */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
            <Input
              label="Unit Price (RS) *"
              type="number"
              min="0"
              value={formData.itemPrice}
              onChange={(e) => {
                let val = e.target.value;
                if (val !== "" && Number(val) < 0) {
                  val = "0";
                }
                setFormData({ ...formData, itemPrice: val });
              }}
              placeholder="0.00"
            />

            <SelectInput
              label="Category *"
              options={categories.map((cat) => ({
                label: cat.name.charAt(0).toUpperCase() + cat.name.slice(1).toLowerCase(),
                value: cat._id,
              }))}
              value={formData.itemCategory}
              onChange={(val) => setFormData({ ...formData, itemCategory: val })}
              placeholder="Select Category"
            />
          </div>

          
          <div className="mt-4">
          <SelectInput
            label="Supplier / Vendor *"
            options={vendors.map((vend) => ({
              label: vend.name,
              value: vend._id,
            }))}
            value={formData.itemVendor}
            onChange={(val) => setFormData({ ...formData, itemVendor: val })}
            placeholder="Select Vendor"
          />
          </div>

          {/* Buttons */}
          <div className="mt-4 grid grid-cols-2 gap-2.5">
            <button
              onClick={onClose}
              className="border border-[#B7B7B7] text-black py-[9px]  text-sm leading-6 rounded-[5px] hover:bg-gray-50 transition"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="bg-[#6D4E8A] text-white py-2.5  text-sm rounded-[5px] hover:bg-[#5a3f75] transition"
            >
              {submitLabel}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
